// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"255d342b","411":"6ea91ad4","453":"f1f94e1d","828":"01fc0555","854":"5683965c"}[chunkId] + ".chunk.js";
};